export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "MovesOffer",
  url: "https://movesoffer.com",
  logo: "https://movesoffer.com/logo512.png",
  description:
    "MovesOffer connects customers with professional moving companies through a competitive auction-based platform.",
  address: {
    "@type": "PostalAddress",
    addressCountry: "CA",
  },
  sameAs: [
    // Add your social media profiles here
    // "https://www.facebook.com/movesoffer",
    // "https://twitter.com/movesoffer",
    // "https://www.linkedin.com/company/movesoffer"
  ],
  contactPoint: {
    "@type": "ContactPoint",
    contactType: "Customer Service",
    email: "movesoffer.support@gmail.com",
  },
};

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "MovesOffer",
  url: "https://movesoffer.com",
  potentialAction: {
    "@type": "SearchAction",
    target: {
      "@type": "EntryPoint",
      urlTemplate:
        "https://movesoffer.com/auctions?search={search_term_string}",
    },
    "query-input": "required name=search_term_string",
  },
};

export const serviceSchema = {
  "@context": "https://schema.org",
  "@type": "Service",
  serviceType: "Moving Services Auction Platform",
  provider: {
    "@type": "Organization",
    name: "MovesOffer",
  },
  areaServed: {
    "@type": "Country",
    name: "Canada",
  },
  description:
    "Compare moving company quotes through our auction-based platform. Get competitive bids from verified movers.",
  offers: {
    "@type": "Offer",
    availability: "https://schema.org/OnlineOnly",
    priceSpecification: {
      "@type": "PriceSpecification",
      priceCurrency: "CAD",
    },
  },
};

export const breadcrumbSchema = (
  items: Array<{ name: string; url: string }>,
) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, index) => ({
    "@type": "ListItem",
    position: index + 1,
    name: item.name,
    item: `https://movesoffer.com${item.url}`,
  })),
});

export const faqSchema = (
  faqs: Array<{ question: string; answer: string }>,
) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((faq) => ({
    "@type": "Question",
    name: faq.question,
    acceptedAnswer: {
      "@type": "Answer",
      text: faq.answer,
    },
  })),
});

export const reviewSchema = (
  reviews: Array<{
    author: string;
    rating: number;
    reviewBody: string;
    datePublished: string;
  }>,
) => ({
  "@context": "https://schema.org",
  "@type": "Product",
  name: "MovesOffer Moving Services",
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: reviews.reduce((sum, r) => sum + r.rating, 0) / reviews.length,
    reviewCount: reviews.length,
  },
  review: reviews.map((review) => ({
    "@type": "Review",
    author: {
      "@type": "Person",
      name: review.author,
    },
    datePublished: review.datePublished,
    reviewBody: review.reviewBody,
    reviewRating: {
      "@type": "Rating",
      ratingValue: review.rating,
      bestRating: 5,
    },
  })),
});

// Factory functions for page-specific structured data

/**
 * Creates schema for home page (combines organization + service)
 */
export const createHomeSchema = () => ({
  "@context": "https://schema.org",
  "@graph": [organizationSchema, serviceSchema]
});

/**
 * Creates schema for moving calculator page
 */
export const createCalculatorSchema = () => ({
  "@context": "https://schema.org",
  "@type": "WebApplication",
  name: "Moving Cost Calculator",
  applicationCategory: "UtilityApplication",
  description: "Free online moving cost calculator to estimate your relocation expenses",
  offers: {
    "@type": "Offer",
    price: "0",
    priceCurrency: "CAD"
  }
});

/**
 * Creates schema for auctions page (ItemList)
 */
export const createItemListSchema = (itemCount: number) => ({
  "@context": "https://schema.org",
  "@type": "ItemList",
  name: "Moving Job Auctions",
  description: "Browse active moving job auctions and place competitive bids",
  numberOfItems: itemCount
});

/**
 * Creates breadcrumb schema for create order page
 */
export const createOrderBreadcrumbSchema = () =>
  breadcrumbSchema([
    { name: "Home", url: "/" },
    { name: "Create Order", url: "/create-order" }
  ]);
